var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm.classes,attrs:{"role":"alert"}},[_c('div',{staticClass:"alert__content"},[(_vm.iconComp)?_c('FontAwesomeIcon',_vm._b({staticClass:"alert__icon"},'FontAwesomeIcon',_vm.iconComp,false)):_vm._e(),_c('span',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }